<template>
  <div :class="$style.faq">
    <aside :class="$style.nav">
      <FaqNav
        :categories
        :active-cat="modelValue"
        @update-value="updateValue"
      />
    </aside>

    <main :class="$style.main">
      <FaqQuestions :questions />
    </main>
  </div>
</template>

<script setup lang="ts">
import type { FaqParams } from './index.js';

defineProps<FaqParams>();
const emits = defineEmits(['update:modelValue']);

const updateValue = (value: string): void => {
  emits('update:modelValue', value);
};
</script>

<style lang="scss" module>
  .faq {
    display: flex;
    gap: 26px;

    @media (max-width: 767px) {
      flex-direction: column;
    }
  }

  .nav {
    flex-shrink: 0;

    @media (min-width: 768px) {
      width: 34%;
    }
  }

  .main {
    @media (min-width: 768px) {
      width: 68%;
    }
  }
</style>